// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

common.View.create('habitats.website.modules.event.Overview', {

    swiper: null,

    onDOMLoad() {
        this.initSwipers();
        this.initScrollNavigation();
    },

    initSwipers()
    {
        this.swiper = new Swiper('.swiper3 .swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            freeMode: true,
            watchOverflow: true,

            // Navigation arrows
            navigation: {
                prevEl: '.swiper3 .swiper-button-prev',
                nextEl: '.swiper3 .swiper-button-next',
            },
        });
    },

    async initScrollNavigation()
    {
        // Get elements for scroll nav
        let mainNavLinks = this.element.find('#sticky-nav a').get(),
            headerHeight = $('header > :visible:first').outerHeight() + this.element.find('#sticky-nav').outerHeight();

        // On scroll
        window.addEventListener('scroll', event => {
            // Get scroll height
            let fromTop = window.scrollY;

            // Go through nav links
            mainNavLinks.forEach(link => {
                // Find section based on css selector
                let section = this.element.find( link.hash.replace( /(-|:|\.|\[|\]|,|=|@)/g, '\\$1' ) ).get(0);

                // Check if scrolled to next section
                if (
                    fromTop > $(section).offset().top - headerHeight &&
                    fromTop < $(section).offset().top + $(section).outerHeight() - headerHeight
                ) {
                    // Set as active
                    link.classList.add('active');

                    // Slide swiper slider
                    this.swiper.slideTo( $(link).parent().index() , false, false );
                } else {
                    link.classList.remove('active');
                }
            });
        });

        // On click, scroll to items
        $(mainNavLinks).on('click', (event) => {
            // Find section based on css selector
            let section = this.element.find( event.currentTarget.hash.replace( /(-|:|\.|\[|\]|,|=|@)/g, '\\$1' ) ).get(0),
                headerHeight = $('header > :visible:first').outerHeight() + this.element.find('#sticky-nav').outerHeight();

            // Get scroll top
            let scrollTop = $(section).offset().top - headerHeight + 1;

            // Scroll to item
            $('html, body')
                .animate({ scrollTop: scrollTop }, 0);

            //
            return false;
        });
    },

});